// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OkO7","col":"styles_col__sUO61"};